module.exports = __webpack_public_path__ + "static/media/coin_img.014216ab.png";